kv.controller('sysRouteCategoryListCtrl', function ($scope, $element, $attrs, $http, resource, $filter, $uibModal, $rootScope, $injector) {
	var vm = new baseCtrl($scope, $element, $attrs, $injector, $filter);
	vm.primaryKey = 'sys_route_category_id';
	vm.entity = 'sys_route_category';

	vm.count = {
		total: 0,
		showing: 0
	};

	vm.getInfinitScroll({
		params: {
			action: 'sys_route_category'
		},
		url: "sys_route_category",
	});

	return vm;
});

